export const LightboxSymbol = Symbol('Lightbox')
export const CurrentLightboxSymbol = Symbol('CurrentLightbox')
export const LightboxUtilsSymbol = Symbol('LightboxUtils')
export const LightboxesLinkUtilsAPISymbol = Symbol('LightboxLinkUtilsAPI')

export const name = 'lightbox' as const
